import { PLOT } from "../constants";

const initialState = {
  plotData: [],
  plotLoading: false,
  plotError: "",
};

export default function plotReducer(state = initialState, action) {
  switch (action.type) {
    case PLOT.SET_PLOT_DATA:
      return {
        ...state,
        plotData: action.payload,
      };
    case PLOT.SET_PLOT_LOADING:
      return {
        ...state,
        plotLoading: action.payload,
      };
    case PLOT.SET_PLOT_ERROR:
      return {
        ...state,
        plotError: action.payload,
      };
    default:
      return state;
  }
}
